class StoreExclusiveForm extends HTMLElement {
	connectedCallback() {
	
		// Elements
		this.inputs = this.getInputs()

		// Events
		this.onSubmit = (e) => this.handleSubmit(e);
		this.inputs.form.addEventListener('submit', this.onSubmit);
		this.setupVariantSync();
	}

	disconnectedCallback() {
		this.inputs.form.removeEventListener('submit', this.onSubmit);
		this.productMainEl?.removeEventListener('change', this.onVariantChange);
	}

	getProductData() {
		return {
			sku: this.getAttribute('data-sku'),
			price: parseFloat(this.getAttribute('data-value')) || 0,
			image: this.getAttribute('data-image'),
			name: this.getAttribute('data-product-name'),
			url: this.getAttribute('data-product-url'),
			id: this.getAttribute('data-product-id'),
			language: this.getAttribute('data-language'),
			color: this.getAttribute('data-color'),
			taille: this.getAttribute('data-taille'),
		}
	}

	getInputs() {
		return {
			email: this.querySelector('[data-exclustore-email]'),
			firstName: this.querySelector('[data-exclustore-first-name]'),
			lastName: this.querySelector('[data-exclustore-last-name]'),
			phone: this.querySelector('[data-exclustore-phone]'),
			subject: this.querySelector('[data-exclustore-subject]'),
			message: this.querySelector('[data-exclustore-message]'),
			form: this.querySelector('form'),
			successMsg: this.querySelector('[data-exclustore-success-msg]'),
			errorDiv: this.querySelector('[data-exclustore-error]'),
			formContent: this.querySelector('[data-exclustore-form-content]'),
			publicKey: this.getAttribute('data-klaviyo-key'),
			metric: this.getAttribute('data-metric')
		}
	}

	// Events to check if variant change
	setupVariantSync() {
		this.productMainEl = document.querySelector('[theme-product-main]');
		this.onVariantChange = (e) => {
			if (e.target.matches('[name^="option"]')) {
				setTimeout(() => this.syncVariantData(), 0);
			}
		};
		this.productMainEl.addEventListener('change', this.onVariantChange);
	}

	// Update web component attributes with new values
	syncVariantData() {

		const productMainEl = this.productMainEl;

		try {
			const productData = JSON.parse(productMainEl.dataset.product);
			const variantInput = productMainEl.querySelector('.product-form__input[name="id"]');
			const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
			if (!variantId) return;

			const variant = productData.variants.find(v => v.id === variantId);
			if (!variant) return;

			if (variant.sku) this.dataset.sku = variant.sku;
			this.dataset.value = (variant.price / 100).toFixed(2);
			if (variant.featured_image?.src) this.dataset.image = variant.featured_image.src;
			if (variant.option1) this.dataset.taille = variant.option1;

			const currentUrl = this.getAttribute('data-product-url');
			if (currentUrl) {
				const url = new URL(currentUrl);
				url.searchParams.set('variant', variant.id);
				this.dataset.productUrl = url.toString();
			}
		} catch (e) { 
			console.error('syncVariantData error:', e); 
		}
	}

	// Loading button
	setLoading(loading) {
		const btn = this.inputs.form.querySelector('[type="submit"]');
		btn.disabled = loading;
		btn.querySelector('.exclustore-form__btn-text').classList.toggle('hidden', loading);
		btn.querySelector('.exclustore-form__btn-loader').classList.toggle('hidden', !loading);
	}

	// Submit form
	async handleSubmit(e) {
		e.preventDefault();

		this.inputs.errorDiv.classList.add('hidden');
		this.setLoading(true);

		// Elements product
		const product = this.getProductData();

		// Elements customer
		const profileAttributes = {
			email: this.inputs.email?.value?.trim(),
			first_name: this.inputs.firstName?.value?.trim(),
			last_name: this.inputs.lastName?.value?.trim(),
			phone_number: this.inputs.phone?.value?.trim(),
		};

		// Properties
		const properties = {
			ProductID: product.id,
			SKU: product.sku,
			ProductName: product.name,
			ProductURL: product.url,
			value: product.price,
			Image: product.image,
			Language: product.language,
			Color: product.color,
			Size: product.taille,
		};

		// Add message and subject to properties
		const subject = this.inputs.subject?.value?.trim();
		const message = this.inputs.message?.value?.trim();
		properties.Subject = subject;
		if (message) properties.Message = message;

		const payload = {
			data: {
				type: 'event',
				attributes: {
					profile: { data: { type: 'profile', attributes: profileAttributes } },
					metric: {
						data: {
							type: 'metric',
							attributes: {
								name: this.inputs.metric
							}
						}
					},
					properties
				}
			}
		};

		try {
			const res = await fetch('https://a.klaviyo.com/client/events/?company_id=' + this.inputs.publicKey, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'revision': '2024-10-15'
				},
				body: JSON.stringify(payload)
			});

			if (res.ok || res.status === 202) {
				this.inputs.formContent.classList.add('hidden');
				this.inputs.successMsg.textContent = this.getAttribute('data-success');
				this.inputs.successMsg.classList.remove('hidden');
			} else {
				throw new Error('Request failed');
			}
		} catch (_) {
			this.inputs.errorDiv.textContent = this.getAttribute('data-error-send');
			this.inputs.errorDiv.classList.remove('hidden');
		} finally {
			this.setLoading(false);
		}
	}
}

customElements.get('exclustore-form') || customElements.define('exclustore-form', StoreExclusiveForm);
